import { render, staticRenderFns } from "./Orgzan.vue?vue&type=template&id=1916dbc8&"
import script from "./Orgzan.vue?vue&type=script&lang=js&"
export * from "./Orgzan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports